// extracted by mini-css-extract-plugin
module.exports = {"label":"label__3t3pE","text":"text__169Jr","requests":"requests__2Uz5y","iconBounding":"iconBounding__BnbAc","icon":"icon__1RCJL","chip":"chip__1BxxI"};